export default [{
  path: '/vacation',
  name: 'vacation',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/vacation/index')
}]
